import {UseFormInputDataValue} from '#/hooks/user-form-input-data';
import {CheckIcon, XMarkIcon} from '@heroicons/react/24/solid';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const FormLabelInput: FunctionComponent<{
  type: HTMLInputElement['type'];
  label: string;
  placeholder: string;
  inputDataValue: UseFormInputDataValue;
  showCheckmark?: boolean;
  validator?: (value: string) => boolean;
}> = ({
  type,
  label,
  placeholder,
  inputDataValue: {value, isModified, isValid, onChange, onReset},
  showCheckmark = false,
}) => {
  const {t} = useTranslation('translation');

  return (
    <div className='w-full'>
      <div className='flex justify-between  ml-1 mb-1.5'>
        <label className='w-full block text-gray-300 text-xs italic font-semibold'>{label}</label>
        {isModified && (
          <button className='text-deepblue text-xs font-semibold hover:opacity-70' onClick={onReset}>
            {t('actions.reset')}
          </button>
        )}
      </div>
      <div className='relative w-full'>
        <input
          className='block w-full outline-none bg-gray-700 px-2 py-1 rounded text-white focus:ring-1 focus:ring-deepblue'
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {showCheckmark && value && (
          <div className='absolute top-0 right-0 h-full aspect-square flex justify-center items-center'>
            <div className={`p-1 rounded-full ${isValid ? 'bg-upgreen/70' : 'bg-downred/70'}`}>
              {isValid ? (
                <CheckIcon className={'w-3 h-3 fill-white stroke-white'} />
              ) : (
                <XMarkIcon className={'w-3 h-3 fill-white stroke-white'} />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
